module.exports = __webpack_public_path__ + "static/media/frame.phone.dfbf4b59.png";